<div class="loren-map-sidepanel" [style.height]="mapHeight">
  <div class="loren-map-sidepanel-header">
    <button
      mat-icon-button
      class="loren-map-sidepanel-close-button"
      id="close-map-sidebar"
      [title]="'infrastructure.close' | transloco"
      (click)="closed.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="loren-map-sidepanel-content">
    <img
      class="loren-map-sidepanel-image"
      [src]="asset().avatar"
      [alt]="asset().name"
      [width]="200"
      [height]="200" />

    <mat-card class="loren-map-sidepanel-status">
      <div class="loren-map-sidepanel-status-value">
        <mat-icon svgIcon="check"></mat-icon>
        <span class="loren-map-sidepanel-status__text">
          {{ "infrastructure.parameters_ok" | transloco }}
        </span>
      </div>

      <div class="loren-map-sidepanel-status-updated">
        <p class="loren-map-sidepanel-status-updated__title">
          {{ "infrastructure.last_updated" | transloco }}
        </p>
        <p class="loren-map-sidepanel-status-updated__value">
          {{ assetUpdated() | lorenDate }}
        </p>
      </div>
    </mat-card>

    <div class="loren-map-sidepanel-details">
      <h3 class="loren-map-sidepanel-title">
        {{ asset().name }}
      </h3>
      <p class="loren-map-sidepanel-info">
        <span class="loren-map-sidepanel-info__title"
          >{{ "infrastructure.groups" | transloco }}:
        </span>

        <span class="loren-map-sidepanel-info__value">
            @let groups = groups$ | async;
            @if(groups) {
                {{groups.join(", ") }}
            }
        </span>
      </p>
      <p class="loren-map-sidepanel-info">
        <span class="loren-map-sidepanel-info__title"
          >{{ "infrastructure.description" | transloco }}:
        </span>
        <span class="loren-map-sidepanel-info__value">{{
          asset().description
        }}</span>
      </p>
        @if (location()) {
            <p class="loren-map-sidepanel-info">
                <span class="loren-map-sidepanel-info__title">{{ "infrastructure.location" | transloco }}:</span>
                <span class="loren-map-sidepanel-info__value">{{ location().lat }},{{ location().lng }}</span>
            </p>
        }
    </div>

    <div class="loren-map-sidepanel-actions">
      <div class="loren-map-sidepanel-actions-buttons">
        @if (location()) {
          <a mat-stroked-button
            class="me-1"
            href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint={{location().lat}},{{location().lng}}"
            target="_blank">
            <img [src]="'/assets/icons/google-street-view-icon.png'" width="18" alt="Google Street View"/>
          </a>
          <a
            mat-stroked-button
            class="me-1"
            href="https://www.google.com/maps?daddr={{location().lat}},{{location().lng}}"
            target="_blank">
            <mat-icon color="primary" class="m-0">directions</mat-icon>
          </a>
        }
      </div>
      <button
        matButton="filled"
        [id]="asset().id.toString()"
        (click)="navigateToAsset()">
        {{ "infrastructure.details" | transloco }}
      </button>
    </div>
  </div>
</div>
